import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header Section */}
      <div className="bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-4">ติดต่อเรา</h1>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              POSTPERTY มีทีมงานที่พร้อมให้บริการ{" "}
              <span className="text-white font-semibold">24 ชั่วโมง</span>
            </p>
            <div className="mt-8 inline-flex items-center gap-2 text-sm text-gray-400">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span>ติดต่อได้ทุกช่องทาง</span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

          {/* Left Column - Contact Channels & Company Info */}
          <div className="space-y-8">
            {/* Contact Channels */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <h3 className="text-2xl font-bold text-black mb-6">ช่องทางการติดต่อ</h3>
              <div className="space-y-4">
                <ContactLink
                  url="https://line.me/ti/p/%40postperty"
                  imgSrc="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/LINE_logo.svg/2048px-LINE_logo.svg.png"
                  altText="line-icon"
                  text="Line Official"
                  bgColor="from-green-50 to-emerald-50"
                />
                <ContactLink
                  url="https://www.facebook.com/PostpertyDotcom"
                  imgSrc="https://cdn-icons-png.flaticon.com/512/5968/5968764.png"
                  altText="facebook-icon"
                  text="FB Fanpage"
                  bgColor="from-blue-50 to-indigo-50"
                />
                <ContactLink
                  url="https://www.instagram.com/postperty/"
                  imgSrc="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                  altText="instagram-icon"
                  text="IG Official"
                  bgColor="from-pink-50 to-rose-50"
                />
                <ContactPhone
                  phoneNumber="tel:02-123-3632"
                  imgSrc="https://cdn-icons-png.flaticon.com/512/6784/6784196.png"
                  altText="phone-icon"
                  text="02-123-3632"
                />
                <ContactPhone
                  phoneNumber="tel:+66910920333"
                  imgSrc="https://cdn-icons-png.flaticon.com/512/6784/6784196.png"
                  altText="phone-icon"
                  text="091-092-0333"
                />
              </div>
            </motion.div>

            {/* Company Info */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h3 className="text-2xl font-bold text-black mb-6">ข้อมูลบริษัท</h3>
              <div className="bg-white border-2 border-black rounded-2xl p-8 shadow-lg">
                <div className="text-center">
                  <h2 className="text-3xl font-bold text-black mb-2">
                    บริษัท โพสต์เพอร์ตี้ จำกัด
                  </h2>
                  <p className="text-xl text-gray-600 mb-6">
                    POSTPERTY CO., LTD.
                  </p>
                </div>
                <div className="border-t-2 border-gray-200 pt-6 mt-6">
                  <div className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-black mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <p className="text-gray-700 leading-relaxed">
                      88/91 หมู่ 8 ต.บางแขม<br />
                      อ.เมืองนครปฐม จ.นครปฐม 73000
                    </p>
                  </div>
                </div>
              </div>

              {/* Join Team Button */}
              <Link to="/jointeam" className="block mt-6">
                <motion.div
                  className="h-14 w-full bg-black rounded-xl text-white flex justify-center items-center shadow-lg text-lg font-medium"
                  whileHover={{ scale: 1.02, backgroundColor: "#1f2937" }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span className="flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    ร่วมงานกับเรา
                  </span>
                </motion.div>
              </Link>
            </motion.div>
          </div>

          {/* Right Column - Map */}
          <motion.div
            className="lg:sticky lg:top-8 h-[500px] lg:h-[700px]"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <div className="h-full w-full rounded-2xl overflow-hidden shadow-xl border-2 border-gray-200">
              <iframe
                title="POSTPERTY CO., LTD"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d242.1788285970681!2d100.03521695239088!3d13.78726510831891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e2e7b5dfd2c139%3A0xa37e8248693e6df8!2sPOSTPERTY%20CO.%2C%20LTD.!5e0!3m2!1sth!2sth!4v1681114387115!5m2!1sth!2sth"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

const ContactLink = ({ url, imgSrc, altText, text, bgColor }) => (
  <Link to={url} target="_blank">
    <motion.div
      className="group relative bg-white border border-gray-300 rounded-xl p-5 shadow-md hover:shadow-xl cursor-pointer transition-all duration-300 overflow-hidden"
      whileHover={{ scale: 1.02, y: -4 }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="flex items-center gap-4">
        <div className={`flex-shrink-0 w-14 h-14 flex items-center justify-center bg-gradient-to-br ${bgColor} rounded-xl shadow-sm group-hover:scale-110 transition-transform duration-300`}>
          <img src={imgSrc} alt={altText} className="w-9 h-9 object-contain" />
        </div>
        <p className="font-semibold text-black flex-1 text-lg">{text}</p>
        <svg
          className="w-6 h-6 text-gray-400 group-hover:text-black group-hover:translate-x-1 transition-all duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 7l5 5m0 0l-5 5m5-5H6"
          />
        </svg>
      </div>
    </motion.div>
  </Link>
);

const ContactPhone = ({ phoneNumber, imgSrc, altText, text }) => (
  <a href={phoneNumber}>
    <motion.div
      className="group relative bg-white border border-gray-300 rounded-xl p-5 shadow-md hover:shadow-xl cursor-pointer transition-all duration-300 overflow-hidden"
      whileHover={{ scale: 1.02, y: -4 }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-gradient-to-br from-gray-50 to-slate-50 rounded-xl shadow-sm group-hover:scale-110 transition-transform duration-300">
          <img src={imgSrc} alt={altText} className="w-9 h-9 object-contain" />
        </div>
        <p className="font-semibold text-black flex-1 text-lg">{text}</p>
        <svg
          className="w-6 h-6 text-gray-400 group-hover:text-black group-hover:scale-110 transition-all duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      </div>
    </motion.div>
  </a>
);

export default Contact;
